export function downloadMockCsvFile() {
  const csv = `nom,lu,favori,archive,risque,received_timestamp,fraud,comment
carte_identite.pdf,True,True,False,3,2025-04-14 18:29:34.284075,False,MRZ
facture_mvr.pdf,True,False,False,3,2025-04-14 18:29:56.939582,False,
facture_garagiste.pdf,True,False,False,3,2025-04-14 18:29:55.662405,False,
Docteller Document.jpg,True,True,False,3,2025-04-25 08:34:42.207306,False,
CNI Bauer Fabrice (2).pdf,True,True,False,3,2025-04-25 08:31:35.666059,False,
cni_ddoc.jpg,True,False,False,3,2025-04-23 07:38:38.613939,False,
ameli_coherence.jpg,True,False,False,3,2025-04-14 18:29:22.008305,True,Commentaires
devis_wefix.pdf,True,False,False,3,2025-04-14 18:39:46.239815,False,
macran_bad_nom_good_mrz_own (1).jpg,True,True,False,3,2025-04-25 08:39:10.841031,True,Test de commentaire
Docteller Document.jpg,True,False,False,2,2025-04-25 08:29:35.746414,False,
Identity Card.pdf,True,False,False,3,2025-05-07 14:41:29.122013,False,
facture_image_an.jpg,True,False,False,3,2025-04-28 13:05:13.693224,False,
Docteller Document.jpg,True,False,False,3,2025-04-25 08:28:20.556512,True,
Marc Impots.pdf,True,False,False,3,2025-04-29 08:05:36.784672,False,
double_mrz.jpg,True,False,False,3,2025-04-29 18:33:45.873101,False,
Docteller Document.jpg,True,False,False,3,2025-04-29 23:13:47.691262,False,
Macran Bad Nom Good (1).jpg,True,False,False,3,2025-05-07 15:31:04.300079,False,
double_ddoc_louis.png,True,False,False,3,2025-04-30 12:09:48.724254,False,
Group 44.png,True,False,False,3,2025-04-30 12:45:39.497809,False,
Group 43.png,True,False,False,3,2025-04-30 12:53:28.506706,False,
cni2021_2ddoc.jpg,True,True,False,3,2025-04-14 18:39:18.879504,False,DDOC
Docteller CNI 2021 (1).jpg,True,False,False,3,2025-05-11 12:54:07.071275,False,
Valentin Johann Document.pdf,True,False,False,3,2025-05-21 17:30:14.208283,False,
double_ddoc_mrz.png,True,False,False,3,2025-04-30 12:07:50.524353,False,
Valentin Johann Mail Mar 5 2025.pdf,True,False,False,0,2025-05-22 17:23:39.601185,False,
assurance_maladie.pdf,True,False,False,3,2025-04-14 18:39:46.522139,True,Modifications localisables
Invoice Image from Docteller.jpg,True,False,False,0,2025-05-22 17:19:05.627480,False,
facture_image_an.jpg,True,False,False,0,2025-05-22 17:20:24.386764,False,
Docteller double ddoc.png,True,False,False,3,2025-05-22 17:39:42.437470,False,
Pediatre Jun 9 2023.pdf,True,False,False,3,2025-05-22 23:27:19.969420,False,
Valentin Johann Remb Sante.pdf,True,False,False,3,2025-05-22 23:27:24.339184,False,
CNI Bauer Fabrice (2).pdf,True,False,False,2,2025-05-22 11:28:58.651898,False,
Invoice Image (1).jpg,True,False,False,0,2025-05-22 17:01:13.470739,False,
Assurance Maladie (4).pdf,True,False,False,3,2025-05-22 17:13:23.898648,False,
Ameli Coherence (2).jpg,True,False,False,3,2025-05-22 17:18:42.101404,False,
facture_image_an.jpg,True,False,False,0,2025-05-22 17:26:28.589238,False,
facture_image_an.jpg,True,False,False,3,2025-05-22 13:05:13.693224,False,Anomalies visibles
`;
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Docteller_fichiers_tutoriel.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
